import React, {useEffect, useState} from 'react';
import { AvailableYears, availableYears } from '../components/yearSelector/availableYears';

export type RegionValue = "eu" | "latam" | "reaseguro";

export type YearSelectedType = {
    year: number;
    niiff: boolean;
};

export type RegionSelectedContextType = {
    regionSelected: RegionValue;
    setRegionSelected: React.Dispatch<React.SetStateAction<RegionValue>>;
    yearSelected: YearSelectedType;
    setYearSelected: React.Dispatch<React.SetStateAction<YearSelectedType>>;
    selectableYears: AvailableYears;
}

const RegionSelectedContext = React.createContext<RegionSelectedContextType>(undefined!);

const RegionSelectedContextProvider = ({ children }: { children: JSX.Element }) => {
    const [regionSelected, setRegionSelected] = useState<RegionValue>("eu");
    const [yearSelected, setYearSelected] = useState<YearSelectedType>(undefined!);
    const [selectableYears, setLoadedYears] = useState<AvailableYears>({ 'en': [], 'es': [] });

    const value = {
        regionSelected,
        setRegionSelected,
        yearSelected,
        setYearSelected,
        selectableYears,
    }

    useEffect(() => {
        setLoadedYears(availableYears);

        const sortedAvailableYears = availableYears.es
            .filter(year => year.region === regionSelected)
            .sort((a, b) => b.year - a.year || (+b.niiff) - (+a.niiff))
    
        setYearSelected(sortedAvailableYears[0]);
      }, [regionSelected, setLoadedYears, setYearSelected]);
    

    return (
        <RegionSelectedContext.Provider value={value}>
            {children}
        </RegionSelectedContext.Provider>
    );
};

export {
    RegionSelectedContextProvider,
    RegionSelectedContext,
}
